<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="list-content result-table nopads" style="width: 100%; scrollbar-width: none; -ms-overflow-style: none;">
        <vue3-datatable
            v-if="items && items.length > 0"
            ref="resultTable"
            :rows="items"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="items.length > 7 ? '52em' : '100%'"
            :sortable="true"
            :row-class="getRowClass"
            cell-class="routa-table-cell"
            @row-click="rowClicked"
        >
            <template #start_time="data">{{ data.value.start }}</template>
        </vue3-datatable>
    </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'RoadReportList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        isMapViewer: {
            type: Boolean,
            default: () => false
        },
        reports: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            loading: 0,
            selected: null,
            items: [],
            fields: [
                {
                    field: 'date',
                    title: this.$t('daily_summary.date'),
                    sort: true,
                    headerClass: 'routa-table-header',
                },
                {
                    field: 'order',
                    title: this.$t('vehicle_position.order'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'task_type',
                    title: this.$t('work_report.task_type'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
            ]
        }
    },
    watch: {
        reports() {
            this.items = this.reports.map((item, index) => {
                    return {
                        id: index,
                        task_type: item.task_type,
                        order: item.order_id,
                        date: item.date,
                    }
                })
        }
    },
    methods: {
        rowClicked(item) {
            this.selected = item
            this.$nextTick(() => this.$emit('rowClicked', item))
        },

        getRowClass(row) {
            let equal = row === this.selected
            return equal ? 'routa-table-row selected-row' : 'routa-table-row'
        }


    }
}
</script>
<style>
</style>
